import { useLocation, useParams, useSearchParams } from "react-router-dom";

import { convertURLParams, parseSearchParams } from "@/utils/helpers";

import { useLectureQuizQuestions } from "../hooks/useLectureQuizQuestions";
import { useState } from "react";
import Question from "./Question";
import Choice from "./Choice";
import Pagination from "@/components/Pagination";
import SpinnerFullPage from "@/components/loadingPage/SpinnerFullPage";
import Alerts from "@/components/Alerts";
import usePermission from "@/hooks/usePermission";

function QuizQandA() {
  const { can } = usePermission();

  const { search } = useLocation();
  const [searchValue] = useState("");
  const [perPage] = useState(10);
  const [searchParams] = useSearchParams();

  const { courseId, lectureId, itemId } = useParams();

  const includeFields = can("read:course:lecture:quiz:quiestion:options") && [
    "options",
  ];

  const page = parseSearchParams(
    searchParams,
    "page",
    (value) => (parseInt(value, 10) < 1 ? 1 : parseInt(value, 10)),
    1
  );

  // filter , sort , page
  const filterAndSortAndPageQuery = convertURLParams(search);

  const { quizQuestions, isPending } = useLectureQuizQuestions({
    courseId,
    lectureId,
    itemId,
    searchValue,
    includeFields,
    perPage,
    page,
    filterAndSortAndPageQuery,
  });
  if (isPending) return <SpinnerFullPage />;

  if (quizQuestions?.data?.length === 0) {
    return (
      <Alerts
        variant={"filled"}
        severity={"error"}
        message={"لا يوجد اسألة بالامتحان"}
      />
    );
  }
  const totalPages = Math.ceil(
    quizQuestions?.meta?.total / quizQuestions?.meta?.per_page
  );

  return (
    <>
      <div className="py-3">
        {quizQuestions?.data?.map((question) => (
          <div key={question.id}>
            <div className="py-5">
              <Question
                question={question.attributes.question}
                image={question.attributes.image}
              />
            </div>
            <div className="grid w-full gap-6 py-5 md:grid-cols-2">
              {question.relationships.options.map((option, optionNum) =>
                option.id && option.attributes.option ? (
                  <Choice key={option.id} choice={option} optionNum={optionNum} />
                ) : null
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center px-2 py-2">
        {totalPages && !isPending && totalPages > 1 ? (
          <Pagination total={totalPages} className="mt-5" />
        ) : null}
      </div>
    </>
  );
}

export default QuizQandA;
